import React, { createContext, PropsWithChildren, useContext } from 'react';

const Context = createContext<string | null>(null);

export const useIdPrefix = (suffix: string | null = null) => {
  const prefix = useContext(Context);
  if (!prefix) {
    console.warn(`No context found for ID: ${suffix}`);
  }
  return prefix ? `${prefix}-${suffix ?? ''}` : undefined;
};

type IdContextProviderProps = {
  prefix: string;
};

export const IdPrefixProvider = ({ children, prefix }: PropsWithChildren<IdContextProviderProps>) => {
  return <Context.Provider value={prefix}>{children}</Context.Provider>;
};
